const ITEMS = [
  "Drive & courses",
  "Fleurs & cadeaux",
  "Colis & retraits",
  "Point A vers point B",
  "Seniors & proches",
  "Lun–Sam, dès 8h",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-forest/15 bg-forest py-4" aria-hidden="true">
      <div className="animate-marquee flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif text-lg italic text-cream/90">{item}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-terra" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
